import { render } from "./HomeView.vue?vue&type=template&id=046c5571&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=046c5571&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\astac\\OneDrive\\Рабочий стол\\twodolist\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046c5571"]])

export default __exports__